import React, { Component } from 'react';
import { Pagination } from "react-bootstrap";
import { CSVLink } from "react-csv";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { PAGE_LIMIT, PARAMS_NAME } from "./config";
import { handleFieldChange } from "../../Utils";

class BidderBids extends Component {
    constructor() {
        super();

        this.state = {
            params: [],
            paramsObj: {},
            browsers: [],
            report: [],
            sortParam: null,
            sortOrder: 1,
            pagesTotal: 0,
            activePage: 1,
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        const paramIndex = this.state.paramsObj[sortParam];
        report.sort((objA, objB) => {
            const valueA = objA[paramIndex] ? objA[paramIndex] : 0;
            const valueB = objB[paramIndex] ? objB[paramIndex] : 0;

            if(valueA > valueB) return 1 * sortOrder;
            else if(valueA < valueB) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(type, filters) {
        this.setState({ isLoading: true });

        if(type === 'browser') this.loadBrowser(filters);
        else this.loadReport(filters);
    }

    loadBrowser(filters) {
        API.BidderBids.getBrowsers(filters)
            .then(({ browsers }) => this.setState({ isLoading: false, browsers }))
    }

    loadReport(filters) {
        API.BidderBids.get(filters)
            .then(({ params, report }) => {
                const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);
                const paramsObj = params.reduce((obj, param, index) => {
                    obj[param] = index;

                    return obj;
                }, {});

                this.setState({ params, paramsObj, report, activePage: 1, pagesTotal, isLoading: false })
            })
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getExportCsvButton() {
        let headers = this.state.params.map(param => ({ key: param, label: PARAMS_NAME[param] }));

        return <CSVLink data={this.state.report} headers={headers} className="btn btn-primary">Export CSV</CSVLink>;
    }

    getTable() {
        let { params, paramsObj, report, total, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table params={params} paramsObj={paramsObj} report={report} total={total} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, browsers } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder Bids"/>
                <Form onSubmit={this.handleSubmit} browsers={browsers}/>
                {this.getExportCsvButton()}

                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default BidderBids;



// WEBPACK FOOTER //
// ./src/scenes/BidderBids/index.js